/**
 * usePrimateAuth — reads Primate auth state from PrimateAuthContext.
 *
 * Group A: Auth & User (7 variables)
 * - isSignedIn, isPro, authLoaded, isAdmin (derived from Clerk via context)
 * - showTerms, showIntercomHint, demoUsageCount (auth-adjacent UI state)
 *
 * No Clerk hooks are called here. This hook is safe to use in any component
 * regardless of whether it's inside ClerkProvider or not.
 */
import { useContext } from 'react';
import { PrimateAuthContext, type PrimateAuthState } from './PrimateAuthContext';

export type { PrimateAuthState };

export function usePrimateAuth(): PrimateAuthState {
  return useContext(PrimateAuthContext);
}
